import { mainnet } from '@wagmi/core/chains';
import { createConfig, http } from '@wagmi/core';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
  injectedWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import type { Hex } from 'viem';
import { e2eMockConnector } from '@/modules/e2e-mock-connector';

// WalletConnect Cloud project id — a public identifier, shipped in the
// browser bundle by design.
const projectId = 'cc8aef5fad63985030ea3e2e9eb0eb38';

const E2E_PRIVATE_KEY = import.meta.env.VITE_E2E_PRIVATE_KEY as Hex | undefined;

export const wagmiConfig =
  E2E_PRIVATE_KEY?.startsWith('0x') === true ?
    createConfig({
      chains: [mainnet],
      connectors: [e2eMockConnector(E2E_PRIVATE_KEY)],
      transports: { [mainnet.id]: http() },
    })
  : getDefaultConfig({
      appName: 'Santiment SSO',
      projectId,
      chains: [mainnet],
      // Drop metaMaskWallet: its module-init `isMetaMask(window.ethereum)` check
      // fails whenever another injected wallet (Phantom, Coinbase, Brave…) shares
      // window.ethereum, silently falling back to a WalletConnect QR instead of
      // opening the extension. Omitting it lets wagmi's EIP-6963 mipd discovery
      // create the real injected connector for MetaMask.
      // injectedWallet renders only when a provider is injected — that's what
      // makes the modal connectable inside mobile in-app dapp browsers (OKX,
      // MetaMask…), where the mobile UI never shows the EIP-6963 "Installed"
      // group and no extension discovery exists.
      wallets: [
        {
          groupName: 'Wallets',
          wallets: [injectedWallet, walletConnectWallet],
        },
      ],
      transports: {
        [mainnet.id]: http(),
      },
    });
